// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__nrKtH","item":"Nav_item__VdHCS","link":"Nav_link__9yFK2","active":"Nav_active__nfBAa","disabled":"Nav_disabled__+pw89"};